import { render, staticRenderFns } from "./google-login.vue?vue&type=template&id=1ef9cdc6&"
import script from "./google-login.vue?vue&type=script&lang=js&"
export * from "./google-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports